import { useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./CreateAccount.css";

const CreateAccount = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onLoginTextClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  return (
    <div className="create-account-div">
      <div className="frame-div78">
        <div className="logo1-div5" onClick={onLogo1ContainerClick}>
          <img className="vector-icon130" alt="" src="../vector130.svg" />
          <img className="vector-icon131" alt="" src="../vector131.svg" />
          <img className="vector-icon132" alt="" src="../vector132.svg" />
          <img className="vector-icon133" alt="" src="../vector133.svg" />
          <img className="vector-icon134" alt="" src="../vector134.svg" />
          <img className="vector-icon135" alt="" src="../vector135.svg" />
          <img className="vector-icon136" alt="" src="../vector136.svg" />
          <img className="vector-icon137" alt="" src="../vector137.svg" />
          <img className="vector-icon138" alt="" src="../vector63.svg" />
          <img className="vector-icon139" alt="" src="../vector89.svg" />
          <img className="vector-icon140" alt="" src="../vector90.svg" />
          <img className="vector-icon141" alt="" src="../vector91.svg" />
          <img className="vector-icon142" alt="" src="../vector142.svg" />
          <img className="vector-icon143" alt="" src="../vector118.svg" />
          <img className="vector-icon144" alt="" src="../vector144.svg" />
          <img className="vector-icon145" alt="" src="../vector145.svg" />
          <img className="vector-icon146" alt="" src="../vector146.svg" />
          <img className="vector-icon147" alt="" src="../vector122.svg" />
          <img className="vector-icon148" alt="" src="../vector148.svg" />
          <img className="vector-icon149" alt="" src="../vector149.svg" />
          <img className="vector-icon150" alt="" src="../vector150.svg" />
          <img className="vector-icon151" alt="" src="../vector151.svg" />
          <img className="vector-icon152" alt="" src="../vector152.svg" />
          <img className="vector-icon153" alt="" src="../vector153.svg" />
          <img className="vector-icon154" alt="" src="../vector154.svg" />
          <b className="shuleeazy-b5">ShuleEazy</b>
        </div>
      </div>
      <div className="frame-div79">
        <b className="you-are-almost-set">You are almost set</b>
        <b className="join-shuleeazy-today">Join ShuleEazy today.</b>
      </div>
      <div className="image-login-div">
        <img
          className="undraw-online-learning-re-qw08-icon1"
          alt=""
          src="../undraw-online-learning-re-qw081.svg"
        />
        <img
          className="undraw-researching-re-fuod-icon1"
          alt=""
          src="../undraw-researching-re-fuod1.svg"
        />
        <img
          className="undraw-active-support-re-b7sj-icon1"
          alt=""
          src="../undraw-active-support-re-b7sj1.svg"
        />
        <img
          className="undraw-online-discussion-re-nn-icon1"
          alt=""
          src="../undraw-online-discussion-re-nn7e1.svg"
        />
        <div className="undraw-online-test-re-kyfx-div1">
          <img className="group-icon5" alt="" src="../group5.svg" />
          <img className="group-icon6" alt="" src="../group6.svg" />
          <img className="group-icon7" alt="" src="../group7.svg" />
          <img className="group-icon8" alt="" src="../group8.svg" />
          <img className="vector-icon155" alt="" src="../vector155.svg" />
          <img className="vector-icon156" alt="" src="../vector156.svg" />
          <img className="vector-icon157" alt="" src="../vector157.svg" />
          <img className="vector-icon158" alt="" src="../vector158.svg" />
          <img className="vector-icon159" alt="" src="../vector159.svg" />
          <img className="group-icon9" alt="" src="../group9.svg" />
          <div className="logo1-div6">
            <img className="vector-icon130" alt="" src="../vector160.svg" />
            <img className="vector-icon131" alt="" src="../vector161.svg" />
            <img className="vector-icon132" alt="" src="../vector162.svg" />
            <img className="vector-icon133" alt="" src="../vector163.svg" />
            <img className="vector-icon134" alt="" src="../vector164.svg" />
            <img className="vector-icon135" alt="" src="../vector165.svg" />
            <img className="vector-icon136" alt="" src="../vector166.svg" />
            <img className="vector-icon137" alt="" src="../vector167.svg" />
            <img className="vector-icon138" alt="" src="../vector168.svg" />
            <img className="vector-icon139" alt="" src="../vector169.svg" />
            <img className="vector-icon140" alt="" src="../vector170.svg" />
            <img className="vector-icon141" alt="" src="../vector171.svg" />
            <img className="vector-icon142" alt="" src="../vector172.svg" />
            <img className="vector-icon143" alt="" src="../vector173.svg" />
            <img className="vector-icon144" alt="" src="../vector174.svg" />
            <img className="vector-icon145" alt="" src="../vector175.svg" />
            <img className="vector-icon146" alt="" src="../vector176.svg" />
            <img className="vector-icon147" alt="" src="../vector177.svg" />
            <img className="vector-icon148" alt="" src="../vector178.svg" />
            <img className="vector-icon149" alt="" src="../vector179.svg" />
            <img className="vector-icon150" alt="" src="../vector180.svg" />
            <img className="vector-icon151" alt="" src="../vector181.svg" />
            <img className="vector-icon152" alt="" src="../vector182.svg" />
            <img className="vector-icon153" alt="" src="../vector183.svg" />
            <img className="vector-icon154" alt="" src="../vector184.svg" />
            <b className="shuleeazy-b6">ShuleEazy</b>
          </div>
        </div>
        <b className="shuleeazy-b7">ShuleEazy</b>
        <b className="making-school-fun-and-accessib1">
          Making school fun and accessible to everyone
        </b>
      </div>
      <div className="frame-div80">
        <button className="buttondesktopprimary6">
          <img
            className="outline-24px-arrow-left"
            alt=""
            src="../outline-24px--arrowleft.svg"
          />
          <b className="save-and-next14">login with google</b>
        </button>
        <button className="buttondesktopprimary7">
          <img
            className="outline-24px-arrow-left"
            alt=""
            src="../outline-24px--arrowleft1.svg"
          />
          <b className="save-and-next14">login with MICROSOFT</b>
        </button>
      </div>
      <div className="frame-div81">
        <div className="line-div3" />
        <b className="or-b">OR</b>
        <div className="line-div3" />
      </div>
      <form className="frame-form">
        <Form.Group className="input-with-label-default">
          <Form.Label>First and Last name</Form.Label>
          <Form.Control type="text" />
        </Form.Group>
        <Form.Group className="input-with-label-default">
          <Form.Label>Email address</Form.Label>
          <Form.Control type="text" />
        </Form.Group>
        <Form.Group className="input-with-label-default">
          <Form.Label>Password</Form.Label>
          <Form.Control type="password" />
        </Form.Group>
      </form>
      <button className="buttondesktopprimary8">
        <b className="save-and-next16">create my account</b>
      </button>
      <div className="frame-div82">
        <div className="frame-div83">
          <div className="rectangle-div" />
          <div className="you-are-almost-set">Remember me</div>
        </div>
        <div className="forgot-password-div">Forgot Password</div>
      </div>
      <div className="frame-div84">
        <div className="you-are-almost-set">Already have an account?</div>
        <b className="login-b" onClick={onLoginTextClick}>
          Login
        </b>
      </div>
    </div>
  );
};

export default CreateAccount;
